module.exports = __webpack_public_path__ + "c6f86127f2d260d9beeece3775c1e3b8.MP3";